<template>
  <div class="user-block">
    <slot name="user">
      <img class="img-circle" :src="`http://localhost:9000/story/${author.avatar.filename}`" alt="User Image" />
      <span class="username"
        ><a href="#">{{ author.username }}</a></span
      >
      <span class="description"
        >Shared publicly - {{ formatDateTime(created_at) }}
      </span>
    </slot>
  </div>
</template>
<script>
import { format, formatDistanceToNow, isToday, isYesterday } from "date-fns";

export default {
  props: {
    author: {
      type: Object,
      required: true,
    },
    created_at: {
      type: String,
      required: true,
    },
  },
  setup() {
    function formatDateTime(datetimeString) {
      if (isToday(datetimeString)) {
        return format(datetimeString, "h:mm a") + " Today";
      } else if (isYesterday(datetimeString)) {
        return format(datetimeString, "h:mm a") + " Yesterday";
      } else {
        const distance = formatDistanceToNow(datetimeString, {
          addSuffix: true,
        });
        return format(datetimeString, "h:mm a") + " " + distance;
      }
    }
    return {
      formatDateTime,
    };
  },
};
</script>